const CustomFooter = () => {
    return <h6>© Copyright PPIC - 2024</h6>
}
  
export default CustomFooter